/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import YouTube from "react-youtube";
import { BASE_URL } from "../Constants";
import { Share } from "@capacitor/share";
import { CgShare } from "react-icons/cg";
import { FiPrinter } from "react-icons/fi";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import axios from "axios";
import { Link } from "react-router-dom";

const ShowOneContentComponent = ({
  data,
  relatedItems = [],
  relatedLoading = false,
  printMode = false,
}) => {
  const hasEnglishSection =
    data.showSecondary === "Y" && Boolean(data.contentSecondary || data.titleSecondary);
  const renderVideoPlayer = () => {
    if (!data || !data.videoPath || printMode) {
      return null; // or any fallback UI if data.videoPath is null or undefined
    }

    const isMediaPath = data.videoPath.startsWith("/media/");

    return (
      <div className="mb-5 mt-3">
        {isMediaPath ? (
          <video controls preload="metadata" className="w-50">
            <source src={data.videoPath} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <YouTube
            videoId={data.videoPath}
            style={{ width: "100%", justifyContent: "center", display: "flex" }}
          />
        )}
      </div>
    );
  };

  let title = data.titlePrimary.split(".").pop();
  const trackContentEvent = (eventType) => {
    return axios.post(BASE_URL + `/api/content/v3/${data.contentId}/event/${eventType}`, {}, {
      withCredentials: true,
    });
  };

  const trackRelatedClick = (targetContentId) => {
    const analyticsUrl = `${BASE_URL}/api/content/v3/${data.contentId}/related/${targetContentId}/analytics`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(analyticsUrl);
      return;
    }

    axios.post(analyticsUrl, {}, { withCredentials: true }).catch((error) => {
      console.error("Error tracking related click:", error);
    });
  };

  const handleShare = async () => {
    try {
      await Share.share({
        title: "Bhajan Lyrics - " + title,
        text: "Bhajan Lyrics - " + title + "\n",
        url: `https://gangadwar.in/content/${data.contentId}`,
        dialogTitle: "Share with Others",
      });
      trackContentEvent("share").catch((error) => {
        console.error("Error tracking share:", error);
      });
    } catch (error) {
      console.error("Error sharing:", error);
    }
  };
  const handlePdfDownload = () => {
    window.open(`${BASE_URL}/api/content/v3/${data.contentId}/pdf`, "_blank", "noopener,noreferrer");
  };
  const handlePlay = () => {
    if (!hasPlayed && data && data.contentId) {
      console.log("onPlay");
      setHasPlayed(true);
      axios.get(BASE_URL + `/api/getmore/audio/${data.contentId}`);
    }
  };
  const handleEnded = () => {
    setHasPlayed(false); // Reset the play state when the audio ends
  };
  const [hasPlayed, setHasPlayed] = useState(false); // State to track if the audio has been played
  const [showEnglishContent, setShowEnglishContent] = useState(false);
  const showRelatedSection = !printMode && (relatedLoading || relatedItems.length > 0);
  const shouldShowEnglishContent = showEnglishContent;

  return (
    <div className={`container ${printMode ? "content-print-shell" : ""}`} style={{ marginTop: "2rem" }}>
      <div className="col-md-12">
        <div className="d-flex justify-content-between align-items-center content-toolbar-wrap">
          <nav aria-label="breadcrumb">
            <ol className={`breadcrumb mb-0 ${printMode ? "print-hidden" : ""}`}>
              <li className="breadcrumb-item" aria-current="page">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                <a href={`/subcategory/${data.subCategory.subCategoryId}`}>
                  {data.subCategory.titlePrimary}
                </a>
              </li>
            </ol>
          </nav>
          <div className={`d-flex align-items-center gap-2 ${printMode ? "print-hidden" : ""}`}>
            <button
              type="button"
              onClick={handlePdfDownload}
              className="btn btn-outline-dark content-action-button"
            >
              <span className="content-action-icon">
                <FiPrinter />
              </span>
              <span> PDF</span>
            </button>
            <a
              href="#"
              onClick={handleShare}
              className="d-flex align-items-center text-decoration-none share-button"
            >
              <b className="ml-auto light-color">
                <span className="mr-2">
                  <CgShare />
                </span>
                &nbsp;Share
              </b>
            </a>
          </div>
        </div>
      </div>
      {printMode ? (
        <div className="print-only print-toolbar">
          <button type="button" className="btn btn-outline-dark content-action-button" onClick={() => window.print()}>
            <span className="content-action-icon">
              <FiPrinter />
            </span>
            <span>PDF</span>
          </button>
        </div>
      ) : null}
      {printMode ? (
        <div className="print-branding center">
          {/* <div className="print-brand-title">Gangadwar Bhajnawali</div> */}
          <div className="print-brand-title">गंगाद्वार भजनावली</div>
          <div className="print-brand-meta">{data.subCategory.titlePrimary}</div>
        </div>
      ) : null}
      <div className="row mt-4 mb-2">
        <div className="col">
          <h1 className="card-title center mt-3">{title}</h1>
        </div>
      </div>
      {/* Custom Image */}
      {data.imagePath ? (
        <div className="content-image center m-3">
          <img
            src={`${BASE_URL}${data.imagePath}`}
            className=""
            alt={title}
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
        </div>
      ) : (
        <></>
      )}
      <p className="card-text center">
        {data.contentPrimary.split("\n").map((item1, key1) => {
          return (
            <span key={key1}>
              {item1}
              <br />
            </span>
          );
        })}
      </p>
      <div className="row " style={{ justifyContent: "center" }}>
        {/* Custom Audio */}
        {data.audioPath && !printMode ? (
          <AudioPlayer
            autoPlay={false}
            preload="metadata"
            src={`${BASE_URL}${data.audioPath}`}
            onPlay={handlePlay}
            onEnded={handleEnded}
            showSkipControls={false}
            showJumpControls={true}
            className="custom-audio-player mt-3"
          />
        ) : (
          <></>
        )}
      </div>
      {/* <div className="" >  */}
      {/* Custom Video */}
      {renderVideoPlayer()}
      {/* </div> */}
      {hasEnglishSection &&
        data.contentSecondary &&
        data.videoPath == null &&
        data.audioPath != null &&
        !printMode && <hr className="my-4" />}

      {hasEnglishSection ? (
        <>
          <div className={`row align-items-center ${printMode ? "print-hidden" : ""}`}>
            <div className="col">
              <div className="d-flex justify-content-center mb-3">
                <button
                  type="button"
                  className="btn btn-outline-dark"
                  onClick={() => setShowEnglishContent((value) => !value)}
                >
                  {showEnglishContent ? "Hide English" : "Read in English"}
                </button>
              </div>
            </div>
          </div>

          <div
            style={{ display: shouldShowEnglishContent ? "block" : "none" }}
            aria-hidden={!shouldShowEnglishContent}
          >
            {data.titleSecondary ? (
              <div className="row">
                <div className="col">
                  <h1 className="card-title center">{data.titleSecondary}</h1>
                </div>
              </div>
            ) : null}

            {data.contentSecondary ? (
              <p className="card-text center">
                {data.contentSecondary.split("\n").map((item1, key1) => {
                  return (
                    <span key={key1}>
                      {item1}
                      <br />
                    </span>
                  );
                })}
              </p>
            ) : null}
          </div>
        </>
      ) : (
        <p></p>
      )}

      {showRelatedSection ? (
        <div className="row mt-5">
          <div className="col">
            <h3 className="card-title center">और भी देखें</h3>
            {relatedLoading ? (
              <div className="row gy-3 row-cols-1 row-cols-md-2 mt-2" aria-busy="true">
                {[1, 2, 3, 4].map((i) => (
                  <div className="col" key={i}>
                    <div
                      className="card h-100 shadow-sm border-0 skeleton-box"
                      style={{ minHeight: "56px", borderRadius: "8px" }}
                    >
                      <div className="skeleton-pulse" />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="row gy-3 row-cols-1 row-cols-md-2 mt-2">
                {relatedItems.map((item) => (
                  <div className="col" key={item.contentId}>
                    <div className="card h-100 shadow-sm border-0">
                      <div className="card-body text-center">
                        <h5 className="mb-2">
                          <Link
                            className="content-link"
                            to={`/content/${item.contentId}`}
                            onClick={() => trackRelatedClick(item.contentId)}
                          >
                            {item.titlePrimary}
                          </Link>
                        </h5>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ShowOneContentComponent;
